import Certification from "../../../models/Certification";
import Product from "../../../models/Product";
import { usePerformRetrieveList } from "../../hooks/usePerformRetrieveList";

const certificationsDataComponent = {
  dataComponentId: "certificationsDataComponentId",
  model: Certification,
  includes: [],
  apiRoute: "certifications",
};

const productsDataComponent = {
  dataComponentId: "productsDataComponentId",
  model: Product,
  includes: [],
  apiRoute: "products",
};

const paginationFilters = {
  pageSize: -1,
  sort: [{ columnName: "name", direction: "asc" }],
};

export const useFetchFilterOptions = () => {
  const {
    isLoading: certificationsLoading,
    data: certifications,
  } = usePerformRetrieveList(certificationsDataComponent, paginationFilters);
  const { isLoading: productsLoading, data: products } = usePerformRetrieveList(
    productsDataComponent,
    paginationFilters
  );

  return { certificationsLoading, productsLoading, certifications, products };
};
